import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BankService } from '@manager-app/storage/service/bank.service';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { extractNumber } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { BankNewComponent } from '../bank-new/bank-new.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { HxLoaderComponent } from 'hx-component';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';

/**
 * Component show list of banks
 *
 * @export
 * @class BankListComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
    selector: 'app-bank-list.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './bank-list.component.html',
    styleUrls: ['./bank-list.component.css'],
    imports: [BankNewComponent, NgIf, NgFor, NgClass, HxLoaderComponent, NgbPagination, TranslocoPipe]
})
export class BankListComponent implements OnInit, OnDestroy {
  list = [];
  pagination = {
    currentPage: 1,
    allItemCount: 0,
    limit: 20,
    maxPage: 1
  };
  bankId;
  page = 1;
  counter = 1;
  isLoading = {
    list: false,
  };
  sub;

  constructor(
    private bankService: BankService,
    private toastr: HcToastrService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private tr: TranslocoService
  ) {
  }

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(params => {
      this.page = extractNumber('page', params) ?? 1;
      this.getList();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private async getList() {
    this.list = [];
    this.isLoading.list = true;
    try {
      const result = await this.bankService.getBankList({page: this.page});
      this.list = result.list || [];
      this.pagination.allItemCount = result.count;
    } finally {
      this.isLoading.list = false;
    }
  }

  // public API
  public updater(event) {
    this.bankId = null;
    if (event) {
      this.getList();
    }
  }

  public updateItem(item) {
    this.bankId = item.id;
  }

  public pageChanged(event) {
    this.router.navigate(['./'], {
      queryParams: {
        page: event,
      },
      relativeTo: this.aRoute
    });
  }

  public async deleteItem(id) {
    try {
      await this.bankService.deleteBank(id);
      this.toastr.success(this.tr.translate('bank-list.ts.deleteBank'));
      this.getList();
    } catch (err) {
      this.toastr.error(this.tr.translate('bank-list.ts.error'));
    }
  }
}
